import React, { useState } from 'react';
import axios from 'axios';
import RenderError from '../../components/RenderError';
import Success from '../../components/Success';
import Submit from '../../components/Submit';
import { replacementOptions } from './config';

function ReplacementAssessment({
  applicationData: { aid, replacedWeedControlMethods, weedControlUse },
  setApplicationData,
  initialView,
  setView
}) {
  const [formData, setFormData] = useState({
    aid: aid ?? '',
    replacedWeedControlMethods: replacedWeedControlMethods ?? {},
    weedControlUse: weedControlUse ?? ''
  });
  const [errors, setErrors] = useState([]);
  const [loading, setLoading] = useState(false);
  const [success, setSuccess] = useState('');

  const handleCheckReplacedMethod = (event) => {
    const { value, checked } = event.target;

    if (value in formData.replacedWeedControlMethods) {
      let newFormData = formData.replacedWeedControlMethods;
      delete newFormData[value];
      setFormData({ ...formData, replacedWeedControlMethods: newFormData });
    } else {
      setFormData({
        ...formData,
        replacedWeedControlMethods: {
          ...formData.replacedWeedControlMethods,
          [value]: value === 'Other (please specify)' ? '' : value
        }
      });
    }
  };

  const handleInputChange = (event) => {
    const { value, name } = event.target;

    if (name === 'replacedWeedControlMethods_other') {
      setFormData({
        ...formData,
        replacedWeedControlMethods: {
          ...formData.replacedWeedControlMethods,
          ['Other (please specify)']: value
        }
      });
    } else {
      setFormData({
        ...formData,
        [name]: value
      });
    }
  };

  const handleSubmit = (event) => {
    event.preventDefault();
    setLoading(true);
    setErrors([]);
    setSuccess('');

    axios
      .post(
        window.wlPipConfig.ajaxUrl +
          '?action=wl_fip_save_flame_weeding_replacement_assessment',
        formData
      )
      .then((res) => {
        setLoading(false);
        setSuccess(res.data.data.message);
        setApplicationData(res.data.data.applicationData);
        setTimeout(() => setView(initialView), 1000);
      })
      .catch((err) => {
        setLoading(false);
        setErrors(err.response.data.data);
      });
  };

  return (
    <div className="fip-unit-form">
      <div className="fip-unit-form-fields">
        <div className="grid__col-xs-12 u--padding-left-0">
          <div className="form__field form__field--required">
            <label className="form__label">
              If applicable, what weed control method(s) are you replacing or
              reducing the use of with this propane-fueled flame weed control
              system?
            </label>
            {errors.replacedWeedControlMethods && (
              <RenderError error={errors.replacedWeedControlMethods} />
            )}
            {replacementOptions.map((option) => (
              <div key={option}>
                <label className="form__checkbox">
                  <input
                    type="checkbox"
                    value={option}
                    checked={option in formData.replacedWeedControlMethods}
                    onChange={handleCheckReplacedMethod}
                  />
                  {option}
                </label>
                {option in formData.replacedWeedControlMethods &&
                  (option === 'Other (please specify)' ? (
                    <div className="u--margin-top-10 u--margin-left-10">
                      <input
                        type="text"
                        name="replacedWeedControlMethods_other"
                        value={formData.replacedWeedControlMethods[option]}
                        onChange={handleInputChange}
                        className="form__input form__input--lg u--width-100"
                      />
                      {errors[option] && <RenderError error={errors[option]} />}
                    </div>
                  ) : (
                    ''
                  ))}
              </div>
            ))}
          </div>
          <div className="form__field form__field--required">
            <label className="form__label">
              Will the unit be used for pre-plant, in-crop or both?
            </label>
            {['Pre-plant', 'In-crop', 'Both'].map((option) => (
              <label className="form__radio" key={option}>
                <input
                  type="radio"
                  name="weedControlUse"
                  value={option}
                  checked={option === formData.weedControlUse}
                  onChange={handleInputChange}
                />
                {option}
              </label>
            ))}
          </div>

          <Submit
            loading={loading}
            handleSubmit={handleSubmit}
            text="Save Section"
            errors={errors}
            disabled={!Boolean(aid)}
          />
          {success && <Success success={success} />}
        </div>
      </div>
    </div>
  );
}

ReplacementAssessment.displayName = 'ReplacementAssessment'; // because WebPack renames the function
export default ReplacementAssessment;
